import * as React from 'react'
import {
  Datagrid,
  List,
  Create,
  Edit,
  SimpleForm,
  TextField,
  TextInput,
  ReferenceField,
  ReferenceFieldController,
  ReferenceInput,
  AutocompleteInput,
  Filter,
  Show,
  SimpleShowLayout,
} from 'react-admin'
import {
  AssessmentField,
  AssessmentSelect,
  ClassSelect,
  EventField,
  EventSelect,
  getFullName,
  StudentField,
} from '../components/selects'
import { useAssessmentIds } from '../utils/useCourseIds'

const ListBase = (props) => {
  const assessment_ids = useAssessmentIds()

  return (
    <List
      filter={assessment_ids ? { assessment_id: assessment_ids } : null}
      filters={<DisqualificatiionFilter />}
      perPage={25}
      {...props}
    >
      <DisqualificatiionList {...props} />
    </List>
  )
}

const ShowBase = (props) => (
  <Show {...props}>
    <DisqualificatiionShow />
  </Show>
)

const CreateBase = (props) => (
  <Create {...props}>
    <DisqualificatiionForm />
  </Create>
)

const EditBase = (props) => (
  <Edit undoable={false} {...props}>
    <DisqualificatiionForm />
  </Edit>
)

export const list = ListBase
export const edit = EditBase
export const show = ShowBase
export const create = CreateBase

const DisqualificatiionFilter = (props) => (
  <Filter style={{ margin: 10 }} {...props}>
    <AssessmentSelect alwaysOn />
    <EventSelect alwaysOn />
    <ClassSelect alwaysOn />
  </Filter>
)

const DisqualificatiionList = (props) => (
  <Datagrid
    rowClick={props.permissions?.includes('admin') ? 'edit' : 'show'}
    {...props}
  >
    <ReferenceFieldController
      label="Assessment"
      reference="instances"
      source="assessment_instance_id"
    >
      {({ referenceRecord }) => (
        <ReferenceField
          basePath="/"
          reference="assessments"
          source="assessment_id"
          record={referenceRecord || {}}
        >
          <TextField source="name" />
        </ReferenceField>
      )}
    </ReferenceFieldController>

    <ReferenceFieldController
      label="Class"
      reference="students"
      source="student_id"
    >
      {({ referenceRecord }) => (
        <ReferenceField
          basePath="/"
          reference="student_groups"
          source="student_group_id"
          record={referenceRecord || {}}
        >
          <TextField source="name" />
        </ReferenceField>
      )}
    </ReferenceFieldController>

    <ReferenceField label="Event" source="event_id" reference="events">
      <TextField source="name" />
    </ReferenceField>

    <ReferenceField label="Student" source="student_id" reference="students">
      <TextField source="first_name" />
    </ReferenceField>

    <TextField source="reason" />
  </Datagrid>
)

const DisqualificatiionShow = (props) => (
  <SimpleShowLayout {...props}>
    <EventField />
    <AssessmentField />
    <StudentField />

    <TextField label="Reason" source="reason" />
    <TextField label="Notes" source="notes" />
  </SimpleShowLayout>
)

const TagsField = ({ record }) =>
  record.scores.map((item, index) => (
    <p key={item}>
      Behavior {index + 1}: {item === 100 ? 'PASS' : 'FAIL'}
    </p>
  ))

TagsField.defaultProps = {
  addLabel: true,
}

const DisqualificatiionForm = (props) => (
  <SimpleForm warnWhenUnsavedChanges {...props}>
    <ReferenceInput
      fullWidth
      allowEmpty={false}
      label="Event"
      perPage={100}
      source="event_id"
      sort={{ field: 'name', order: 'ASC' }}
      filterToQuery={(searchText) => ({ q: { name: searchText } })}
      reference="events"
    >
      <AutocompleteInput optionText="name" translateChoice={false} />
    </ReferenceInput>

    <ReferenceInput
      fullWidth
      allowEmpty={false}
      label="Assessment"
      perPage={100}
      source="assessment_id"
      sort={{ field: 'name', order: 'ASC' }}
      filterToQuery={(searchText) => ({ q: { name: searchText } })}
      reference="assessments"
    >
      <AutocompleteInput optionText="name" translateChoice={false} />
    </ReferenceInput>
    <ReferenceInput
      fullWidth
      allowEmpty={false}
      label="Student"
      perPage={100}
      source="student_id"
      sort={{ field: 'first_name', order: 'ASC' }}
      filterToQuery={(searchText) => ({ q: { first_name: searchText } })}
      reference="students"
    >
      <AutocompleteInput optionText={getFullName} translateChoice={false} />
    </ReferenceInput>

    <TextInput fullWidth label="Reason" source="reason" />
    <TextInput fullWidth label="Notes" source="notes" />
  </SimpleForm>
)
